import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Background from '../../common/images/side-bg.jpg';
import loginImg from "../../common/images/login-logo.png"
class MenuSidebar extends Component {
	
	constructor(props)
	{
		super(props);
		this.state = {
			  currentpage:this.props.currentpage,
			  admin_id:localStorage.getItem('admin_id')
		};
		
    }
	
	activeMenu(currentPage) {
        let status = '';
            if(this.state.currentpage===currentPage) {
                status = 'nav-item has-sub active'
            }else{
            status = 'nav-item has-sub enable';
        }
        return status;
    }
	
  render() {
    return (	
	<div className="sidebar-menu mobi-close">
	   <div className="main-menu menu-fixed menu-dark menu-accordion menu-shadow expanded" data-scroll-to-active="true" >
  <div className="navbar-header expanded">
    <ul className="nav navbar-nav flex-row position-relative">
      <li className="nav-item mr-auto">
        <a className="navbar-brand" href="#">
        {/* <img src={loginImg} /> */}
          <h3 className="brand-text">Admin</h3>
        </a>
      </li>
      <li className="nav-item d-md-none"><a href="javascript:void(0)" className="nav-link close-navbar mb-side-nav"><i className="ft-x"></i></a></li>
    </ul>
  </div>
  <div className="navigation-background" style={{background: `url(${Background})`}}></div>
  <div className="main-menu-content ps ps--active-y" style={{height: "587px;"}}>
  <Scrollbars className="custom-scroll-wrap">
    <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
      <li className={this.activeMenu('dashboard')}>
        <a href="/dashboard">
          <i className="fa fa-dashboard"></i>
          <span className="menu-title" data-i18n="">Dashboard</span>
        </a>
      </li>
      
      <li className={this.activeMenu('user')}>
        <a title="User" href="/user">
          <i className="fa fa-users"></i>
          <span className="menu-title" data-i18n="">Users</span>
        </a>
      </li>    
      <li className={this.activeMenu('contractor')}>
        <a href="/contractor">
          <i className="fa fa-dropbox" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Contractors</span>
        </a>
      </li>
      <li className={this.activeMenu('subcontractor')}>
        <a href="/subcontractor">
          <i className="fa fa-dropbox" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Sub Contractors</span>
        </a>
      </li>
      <li className={this.activeMenu('project')}>
        <a href="/project">
          <i className="fa fa-dropbox" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Projects</span>
        </a>
      </li>
      <li className={this.activeMenu('job')}>
        <a href="/job">
          <i className="fa fa-dropbox" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Jobs</span>
        </a>
      </li>
      <li className={this.activeMenu('companies')}>
        <a href="/companies">
          <i className="fa fa-dropbox" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Companies</span>
        </a>
      </li>

      {/* <li className={this.activeMenu('leads')}>
        <a title="Leads" href="/leads">
          <i className="fa fa-dropbox"></i>
          <span className="menu-title" data-i18n="">Leads</span>
        </a>
      </li>   */}
     
      
      <li className={this.activeMenu('adsCategory')}>
        <a title="Advertisement" href="/adsCategory">
          <i className="fa fa-audio-description"></i>
          <span className="menu-title" data-i18n="">Advertisement Category</span>
        </a>
      </li>
      <li className={this.activeMenu('advertisement')}>
        <a title="Advertisement" href="/advertisement">
          <i className="fa fa-audio-description"></i>
          <span className="menu-title" data-i18n="">Advertisement</span>
        </a>
      </li>

      <li className={this.activeMenu('abusiveword')}>
				<a href="/abusivewords">
				<i className="ft-edit" aria-hidden="true"></i>
				<span className="menu-title" data-i18n="">Abusive Words</span>
				</a>
			</li>

      <li className={this.activeMenu('chat')}>
				<a href="/chat">
				<i className="fa fa-comments-o" aria-hidden="true"></i>
				<span className="menu-title" data-i18n="">Emoji Management</span>
				</a>
			</li>
    
      <li className={this.activeMenu('FaqCategory')}>
        <a href="/Faqcategory">
          <i className="fa fa-comments-o" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Faq Category</span>
        </a>
      </li>

      <li className={this.activeMenu('Faq')}>
        <a href="/Faq">
          <i className="fa fa-comments-o" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Faq</span>
        </a>
      </li>

      {/* <li className={this.activeMenu('Aifeed')}>
        <a href="/aifeed">
          <i className="ft-faq" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Manage AI Feed</span>
        </a>
      </li> */}
      <li className={this.activeMenu('fonts')}>
        <a href="/fonts">
          <i className="fa fa-font"></i>
          <span className="menu-title" data-i18n="">Fonts</span>
        </a>
      </li>
      {this.state.admin_id == 1 ?<li className={this.activeMenu('templates')}>
        <a href="/templates">
          <i className="fa fa-envelope"></i>
          <span className="menu-title" data-i18n="">Email Templates</span>
        </a>
        </li>:''} 
      {/* <li className={this.activeMenu('dashboardmanagement')}>
        <a title="Dashboard Management Builder" href="/dashboardmanagement">
          <i className="ft-tab-management"></i>
          <span className="menu-title" data-i18n="" >Dashboard Management</span>
        </a>
      </li> */}

        <li className={this.activeMenu('shortcuticon')}>
          <a title="Shortcut icon" href="/shortcuticon">
            <i className="fa fa-dropbox" aria-hidden="true"></i>
            <span>Shortcut Icons</span>
          </a>
		    </li>
      
	    <li className={this.activeMenu('setting')}>
        <a href="/setting">
          <i className="ft-settings"></i>
          <span className="menu-title" data-i18n="">Settings</span>
        </a>
      </li>
      
    </ul>
    </Scrollbars>
  </div>
</div>
	</div>		

	
    );
  }
}

export default MenuSidebar;